<template>
  <v-app>
    <v-content>
      <Layout />
    </v-content>
  </v-app>
</template>

<script>
import Layout from './components/Layout.vue'

export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style>
a {
  text-decoration: none;
  color: rgb(135, 0, 0) !important;
  font-weight: 800;
}
</style>
